<div (click)="getAndOpenInvoicePDF(invoiceDocumentId)">
  <img class="icon open-icon" src="/assets/icons/open_new_page.svg">
</div>